exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".prSubsc[data-v-30a63d00]{margin:0 auto;padding:0 24px;max-width:450px}.prSubsc__banner[data-v-30a63d00],.prSubsc__copy[data-v-30a63d00]{display:block;max-width:100%;vertical-align:middle;margin:0 auto}.prSubsc__copy[data-v-30a63d00]{margin:0 0 24px}.prSubsc__banner[data-v-30a63d00]{-webkit-box-shadow:5px 5px 15px rgba(0,0,0,.15);box-shadow:5px 5px 15px rgba(0,0,0,.15);border-radius:6%;-webkit-transition:.2s;transition:.2s}.prSubsc__banner[data-v-30a63d00]:hover{opacity:.8}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-30a63d00","scoped":true,"sourceMap":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/utvStore/components/YearLuck/y2022/prSubsc.vue
// module id = mJ1n
// module chunks = 0